/* src/components/YDWidgets/ydWidgets.js */
import React from 'react';
import { useQuery } from '@apollo/client';
//import { fullPageLoadingIndicator } from '../LoadingIndicator';
import YDWidget from './ydWidget';
//const YDWidget = React.lazy(() => import('./ydWidget'));

import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './ydWidgets.module.css';
import GET_WIDGETS from '../../queries/getWidgets.graphql';

// import GalleryWidget from '../GalleryWidget';
// const GalleryWidget = React.lazy(() => import('../GalleryWidget'));
//const Gallery = React.lazy(() => import('../Gallery'));
import Gallery from '../Gallery';
import YDBannerGroup from '../YDBanners';
//const YDBannerGroup = React.lazy(() => import('../YDBanners'));

const isDevelopmentMode = process.env.NODE_ENV === 'development';

// Stub for missing global function
if (typeof globalThis._ydWidgetsHasPermission === 'undefined') {
    globalThis._ydWidgetsHasPermission = function(type, code, position, place) {
        // Default: allow all widgets in standalone mode
        return true;
    };
}

const YDWidgets = props => {
    const { type, code, position, place } = props;
    //
    //    return null;

    if (!globalThis._ydWidgetsHasPermission(type, code, position, place)) {
        console.log(
            `YDWidgets: No permission for ${type}|${code}|${position}|${place}`
        );
        return null;
    }

    const classes = useStyle(defaultClasses, props.classes);

    const { loading, error, data } = useQuery(GET_WIDGETS, {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
        variables: {
            type: type,
            code: code,
            position: position,
            place: place
        }
    });

    if (loading) {
        return null;
        //        return fullPageLoadingIndicator;
    }

    if (error) {
        if (isDevelopmentMode) {
            console.error(error);
            return (
                <div className={classes.error}>Error: {error.toString()}</div>
            );
        } else {
            return '';
        }
    }
    /*
    console.log(
        'YDWidgets',
        type,
        code,
        position,
        place,
        data.cmsWidgets.widgets.length,
        data
    );*/

    // there are no widgets available for the requested position
    if (
        !data.cmsWidgets ||
        !data.cmsWidgets.widgets ||
        data.cmsWidgets.widgets.length == 0
    ) {
        if (process.env.YD_WIDGET_SHOW_HINTS == 'true') {
            return (
                <div className={classes.debug}>
                    Position:
                    <strong>
                        {type}/{code}/{position}/{place}
                    </strong>
                </div>
            );
        }
        return null;
    }

    const widgets = data.cmsWidgets.widgets
        .map((item, index) => {
            if (
                item.type ===
                'Magento\\CatalogWidget\\Block\\Product\\ProductsList'
            ) {
                return (
                    <Gallery
                        items={item.data.product}
                        classes={classes}
                        key={index}
                        showAddToCart={true}
                    />
                );
            } else if (
                item.type === 'YoungDogs\\Banner\\Block\\Widget\\Banner'
            ) {
                return (
                    <YDBannerGroup
                        bannergroup={item.data.banner}
                        classes={classes}
                        key={index}
                    />
                );
            } else {
                if (!item.html) {
                    console.error(
                        `YDWidgets: empty widget response! ${type}|${code}|${position}|${place}`
                    );
                    return null;
                }
                return <YDWidget key={index} item={item} />;
            }
        })
        .filter(widget => !!widget);

    const title =
        process.env.YD_WIDGET_SHOW_HINTS == 'true'
            ? `${type}/${code}/${position}/${place}`
            : null;

    return widgets && widgets.length ? (
        <span data-layout-position={title}>{widgets}</span>
    ) : null;
};

export default YDWidgets;
